import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Prduction'

  }
];

@Component({
  selector: 'page-pd-check-result',
  templateUrl: './pd-check-result.html',
  styleUrls: ['./pd-check-result.scss']
})

export class PagePdCheckResult implements OnInit {
  //initial & Search
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  loadingIndicator: boolean = true;

  lines = [];
  items = [];
  tpr_id: String;
  tpr_name:String;
  lineName: String;
  shift:String;
  total:any=0;
  kbBox:any=0;

  //dialog
  dialogRefWarning: MdDialogRef<WarningPdCheckResultDialog>;
  dialogRef: MdDialogRef<pdCheckResultDialog>;
  setId: any;
  dateTime: any; date_selected: any;
  sysPath: String = environment.sysPath;
  ckSave: Boolean = false;
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {
    singleSelection: true,
    text: "Select line",
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    enableSearchFilter: true,
    classes: "col-md-12"
  };
  constructor(private fb: FormBuilder, private httpservice: httpservice, private router: Router, public dialog: MdDialog, private _sharedService: SharedService) {
    this.dateTime = Date.now();
    let date = new Date();
    this.date_selected = date.toISOString().split('T')[0];
    this.shift = "1";
    this.getlines();
    this._sharedService.emitChange(this.pageTitle);
    this.fullScreen();
    this.dialog.closeAll();
  }



  onItemSelect(item: any) {
    //console.log(item);
    this.tpr_id = this.selectedItems[0].id;
    this.tpr_name = this.selectedItems[0].itemName;
    console.log('onItemSelect',this.selectedItems,this.tpr_id);

  }


  OnItemDeSelect(item: any) {
    //console.log(item);
    //console.log(this.selectedItemsProcess);
  }
  onSelectAll(items: any) {
    //console.log(items);
  }
  onDeSelectAll(items: any) {
    //console.log(items);
  }


  fullScreen() {
    let elem = document.documentElement;
    let methodToBeInvoked = elem.requestFullscreen || elem['mozRequestFullscreen']
      ||
      elem['msRequestFullscreen'];
    if (methodToBeInvoked) methodToBeInvoked.call(elem);
  }



  getlines() {
    this.httpservice.fetchget('getJSON_line_name.php?', data => {
      this.lines = data;
      for (let i = 0; i < data.length; i++) {
        this.dropdownList.push({ "id": data[i].tpr_id, "itemName": data[i].tpr_name });
      }

    });
  }



  search() {
    this.ckSave = true;
    this.total=0;this.kbBox=0;
    this.httpservice.fetchget('getJSON_pd_check_result.php?shift='+this.shift+'&tpr_id='+this.tpr_id+'&date_selected='+this.date_selected, data => {
      this.ckSave = false;
      this.items = data;
      for(let i = 0;i<data.length;i++){
        this.total +=  parseInt(data[i].tb135_lotsize);
        this.kbBox = i+1;
      }
  
      console.log('data',data);
      //this.getCheckPoint();
    });
  }

  ngOnInit() {

  }

}
//dialog
@Component({
  selector: 'pd-check-result-dialog',
  templateUrl: 'dialog.html',
})
export class pdCheckResultDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<pdCheckResultDialog>) { }
}

//warning
@Component({
  selector: 'warning-pd-check-result-dialog',
  templateUrl: 'warning.html',
})
export class WarningPdCheckResultDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningPdCheckResultDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/mobile/pd-check-result.ts